import type { ZodTypeAny } from 'zod';
import { z } from 'zod';

import type { FieldDescriptor } from '../../types/common';

import { MultiSelectModalFieldElement } from './MultiSelectModalField';
import type { MultiSelectModalField } from './types';

const createValidationSchema = (field: MultiSelectModalField) => {
  let fieldSchema: ZodTypeAny = z.array(z.union([z.string(), z.number(), z.boolean()]), {
    required_error: 'Please select at least one option',
  });

  if (field.validation?.min) {
    const message =
      field.validation.minErrorMessage || `Please select at least ${field.validation.min} options`;
    // @ts-expect-error Some weird typing
    fieldSchema = fieldSchema.min(field.validation.min, {
      message,
    });
  }

  if (field.validation?.isOptional) {
    fieldSchema = fieldSchema.optional();
  }

  return fieldSchema;
};

const Descriptor: FieldDescriptor<MultiSelectModalField> = {
  FieldComponent: MultiSelectModalFieldElement,
  name: 'MultiSelectModalField',
  createValidationSchema,
};

export default Descriptor;

export type { MultiSelectModalField as FieldType };
